import { CheckCircle2, Clock, AlertTriangle, XCircle, CircleDot, Thermometer, RotateCcw, ShieldCheck, CloudOff, Cloud } from "lucide-react";

const MAP = {
  PENDING: { label: "Pendiente", Icon: Clock, cls: "bg-amber-100 text-amber-700 border-amber-200" },
  NOT_REQUIRED: { label: "No aplica", Icon: CircleDot, cls: "bg-slate-100 text-slate-500 border-slate-200" },
  LATE: { label: "Atrasado", Icon: AlertTriangle, cls: "bg-orange-100 text-orange-700 border-orange-200" },
  MISSED: { label: "Omitido", Icon: XCircle, cls: "bg-red-100 text-red-700 border-red-200" },
  COMPLETED: { label: "Realizado", Icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  INCIDENT: { label: "Fuera de rango", Icon: Thermometer, cls: "bg-red-100 text-red-700 border-red-200" },
  OK: { label: "Dentro de rango", Icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  OUT_OF_RANGE: { label: "Fuera de rango", Icon: Thermometer, cls: "bg-red-100 text-red-700 border-red-200" },
  OPEN: { label: "Abierta", Icon: AlertTriangle, cls: "bg-red-100 text-red-700 border-red-200" },
  IN_PROGRESS: { label: "En proceso", Icon: CircleDot, cls: "bg-amber-100 text-amber-700 border-amber-200" },
  WAITING_RECHECK: { label: "Esperando 2ª medición", Icon: RotateCcw, cls: "bg-amber-100 text-amber-700 border-amber-200" },
  RESOLVED: { label: "Resuelta", Icon: ShieldCheck, cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  REOPENED: { label: "Reabierta", Icon: RotateCcw, cls: "bg-orange-100 text-orange-700 border-orange-200" },
  NEW: { label: "Nueva", Icon: CircleDot, cls: "bg-red-100 text-red-700 border-red-200" },
  READ: { label: "Leída", Icon: CheckCircle2, cls: "bg-slate-100 text-slate-600 border-slate-200" },
  SYNCED: { label: "Sincronizado", Icon: Cloud, cls: "bg-blue-100 text-blue-700 border-blue-200" },
  PENDING_SYNC: { label: "Pendiente de sincronización", Icon: CloudOff, cls: "bg-slate-100 text-slate-600 border-slate-200" },
  CRITICAL: { label: "Crítico", Icon: AlertTriangle, cls: "bg-red-100 text-red-700 border-red-200" },
  HIGH: { label: "Alto", Icon: AlertTriangle, cls: "bg-orange-100 text-orange-700 border-orange-200" },
  MEDIUM: { label: "Medio", Icon: CircleDot, cls: "bg-amber-100 text-amber-700 border-amber-200" },
  LOW: { label: "Bajo", Icon: CircleDot, cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function StatusPill({ status, label, size = "sm", testid }) {
  const cfg = MAP[status] || { label: label || status, Icon: CircleDot, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  const Icon = cfg.Icon;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${pad} ${cfg.cls}`}>
      <Icon className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} />
      {label || cfg.label}
    </span>
  );
}
